<template>

  <div
    :style="styles"
    class="page-block">

    <div
      :style="bgStyles"
      class="page-block__bg-color"/>

    <file-background
      v-if="bgFile"
      :value="bgFile"
      :style="bgStyles"
      :contain="bgImageContain"
      class="page-block__bg-file"/>

    <div
      :class="overlayClasses"
      class="page-block__overlay">

      <div
        :class="wrapperClasses"
        class="page-block__wrapper"
        :style="{backgroundColor: wrapperColor}">

        <h1
          v-if="title"
          class="page-block__title text-weight-bold q-mb-lg">
          {{ title }}
        </h1>

        <slot/>

      </div>

    </div>

  </div>

</template>

<script>

  import FileBackground from '@src/components/file/file-background';

  export default {
    name: 'page-block',
    props: {
      title: {
        type: String,
        default: '',
      },
      bgFile: {
        type: Object,
      },
      bgColor: {
        type: String,
      },
      bgOpacity: {
        type: Number,
      },
      wrapperColor: {
        type: String,
      },
      textColor: {
        type: String,
        default: '',
      },
      textAlign: {
        type: String,
        default: '',
      },
      widthClass: {
        type: String,
        default: '',
      },
      overlayClass: {
        type: String,
        default: '',
      },
      wrapperClass: {
        type: String,
        default: '',
      },
      wide: {
        type: Boolean,
        default: false,
      },
      noBody: {
        type: Boolean,
        default: false,
      },
      bgImageContain: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      FileBackground,
    },
    computed: {
      styles() {

        return {
          color: this.textColor,
          textAlign: this.textAlign,
        };
      },
      bgStyles() {

        const opacity = this.bgOpacity === undefined
          ? 1
          : this.bgOpacity;

        return {
          opacity,
          backgroundColor: this.bgColor,
        };
      },
      overlayClasses() {

        return {
          'wide': this.wide,
          'bs-pa': !this.noBody,
          'no-body': this.noBody,
          [this.widthClass]: this.widthClass,
          [this.overlayClass]: this.overlayClass,
        };
      },
      wrapperClasses() {

        return {
          [this.wrapperClass]: this.wrapperClass,
        };
      },
    },
  };

</script>

<style lang="scss">

  $cls: page-block;

  .page-block {
    position: relative;

    &__bg-file,
    &__bg-color {
      @include abs-fill;
    }

    &__overlay {
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;
      position: relative;
    }

    &__wrapper {
      margin: 0 auto;
    }

    &__title {
      position: relative;

      &:before {
        content: "";
        width: 100px;
        height: 100px;
        display: block;
        position: absolute;
        background-size: 100%;
        background-image: url("/images/logo/logo-symbols.svg#logo-rounded");
      }
    }

    .wide > .#{$cls}__wrapper,
    .no-body > .#{$cls}__wrapper {
      padding: 0;
      max-width: none;
    }
  }

</style>
